import {
  SCAFFOLD_PLANKORIENTATION,
  SCAFFOLD_PLANKTYPE,
  SCAFFOLD_STANDARDLENGTH,
} from "../../../enums";

export const BAYWIDTHS = {
  MM700: 0.7,
  MM1000: 1,
  MM1250: 1.25,
};

export const BAYLENGTHS = {
  MM700: 0.7,
  MM1000: 1,
  MM1050: 1.05,
  MM1250: 1.25,
  MM1500: 1.5,
  MM1750: 1.75,
  MM2000: 2,
  MM2500: 2.5,
  MM3000: 3,
};

export const STANDARDLENGTHS = {
  M2: SCAFFOLD_STANDARDLENGTH.M2,
  M3: SCAFFOLD_STANDARDLENGTH.M3,
  M4: SCAFFOLD_STANDARDLENGTH.M4,
};

export const LOADINGBAYWIDTHS = {
  MM700: 0.7,
  MM1000: 1,
  MM1250: 1.25,
};

export const LOADINGBAYLENGTHS = {
  MM700: 0.7,
  MM1000: 1,
  MM1250: 1.25,
  MM1500: 1.5,
  MM1750: 1.75,
  MM2000: 2,
  MM2500: 2.5,
  MM3000: 3,
};

export const LOADINGBAYLOADCLASSES = {
  LOADCLASS1: 1,
  LOADCLASS2: 2,
  LOADCLASS3: 3,
  LOADCLASS4: 4,
  LOADCLASS5: 5,
  LOADCLASS6: 6,
};

export const PLANKWIDTHS = {
  MM290: 0.29,
  MM300: 0.3,
  MM320: 0.32,
  MM600: 0.6,
  MM610: 0.61,
};

export const PLANKORIENTATIONS = {
  LONGITUDINAL: SCAFFOLD_PLANKORIENTATION.LONGITUDINAL,
};

export const PLANKTYPES = {
  STEEL: SCAFFOLD_PLANKTYPE.STEEL,
  ALUMINUM: SCAFFOLD_PLANKTYPE.ALUMINUM,
};

export const CONSOLEWIDTHS = {
  MM200: 0.2,
  MM300: 0.3,
  MM400: 0.4,
  MM700: 0.7,
};

export const STAIRWIDTHS = {
  MM700: 0.7,
  MM1250: 1.25,
};

export const STAIRLENGTHS = {
  MM2500: 2.5,
};
